module.exports = __webpack_public_path__ + "img/drag.61733584.svg";